import Vue from 'vue';
import Router from 'vue-router';
import account from './modules/account/index';
import learningCenter from './modules/learning-center/index';
import student from './modules/student/index';
import createStudent from './modules/student/create';
import activities from './modules/activities/index';
import share from './modules/share/index';
import dualMeet from './modules/dual-meet/index';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['@/components/Login'], resolve),
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: resolve => require(['@/components/ForgotPassword'], resolve),
    },
    account,
    student,
    createStudent,
    learningCenter,
    activities,
    share,
    dualMeet,
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js